import {BaseForm} from 'craftable';
import {getValidationFieldClasses} from '../../utils.js'

function documentWysiwygInsert(insertText){
    var $wysiwyg = $('#wysiwyg');
    $wysiwyg.trumbowyg('execCmd', {cmd: 'insertHTML', param: '<span class="wysiwyg-custom-insert">'+insertText+"</span>&nbsp;"});
}

export default {
	mixins: [BaseForm],
    props: {
        'trans': {
            //type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
        'attendancePropsButtons': {
            //type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
        'restaurantDynamicFieldsNames': {
            //type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
    },
    data: function() {

        var adtButtons = {};
        var adtButtonsList = {
            "employees": [],
            "contracts": [],
        };
        var groups = [];

        for(var group in this.attendancePropsButtons)
        {
            var selButtons = [];
            var groupButtons = this.attendancePropsButtons[group];
            for(var x in groupButtons)
            {
                var nameRaw = x.replace("[[","").replace("]]","").replace("custom_","");
                // the "custom" group holds dynamic fields (named by the company) and a few system ones (translated)
                var buttonLabel = (group == "custom" && this.restaurantDynamicFieldsNames[nameRaw])
                    ? this.restaurantDynamicFieldsNames[nameRaw]
                    : this.trans[groupButtons[x]];
                selButtons.push("insert_"+groupButtons[x]);
                adtButtons["insert_"+groupButtons[x]] =
                    {
                        fn: function(a) {
                            documentWysiwygInsert(a);
                        },
                        tag: 'xy',
                        title: buttonLabel,
                        text: buttonLabel,
                        isSupported: function () { return true; },
                        param: '[['+groupButtons[x]+']]' ,
                        forceCSS: false,
                        hasIcon: false
                    };
            }

            adtButtons[group] = {
                dropdown: selButtons,
                title: this.trans[group],
                hasIcon: false
            };
            groups.push(group);
        }

        return {
             documentWysiwygConfig: {
                removeformatPasted: true,
                semantic: false,
                resetCss: true,
                btns: [
                    ['formatting'],
                    ['strong', 'em', 'underline',  'del', 'superscript', 'subscript'],
                    ['align'],
                    ['unorderedList', 'orderedList', 'table'],
                    ['foreColor', 'backColor'], ['insertImage'],
                    ['link', 'image'], ['horizontalRule'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['removeformat'],
                    ['fullscreen', 'viewHTML'],
                    groups

                ],
                btnsDef: adtButtons
            },

        }
    },

    methods: {

        //fixed default Craftable onFail method
        onFail: function onFail(errors) {
            this.submiting = false;
            var bag = this.$validator.errors;
            bag.clear();
            Object.keys(errors).map(function (key) {
                var splitted = key.split('.', 2);
                // we assume that first dot divides column and locale (TODO maybe refactor this and make it more general)
                if (splitted.length > 1) {
                    bag.add({ field: splitted[0] + '_' + splitted[1], msg: errors[key][0]});
                } else {
                    bag.add({ field: key, msg: errors[key][0]});
                }
            });
        },

        getRepeaterRows(fieldId, subfields) {
            if (!this.form.dynamicFieldsValues) {
                this.$set(this.form, 'dynamicFieldsValues', {});
            }

            var existingValue = this.form.dynamicFieldsValues[fieldId];
            if (Array.isArray(existingValue)) {
                return this.ensureRepeaterHasAtLeastOneRow(fieldId, existingValue, subfields);
            }

            if (!existingValue) {
                this.$set(this.form.dynamicFieldsValues, fieldId, []);
                return this.ensureRepeaterHasAtLeastOneRow(fieldId, this.form.dynamicFieldsValues[fieldId], subfields);
            }

            if (typeof existingValue === 'string') {
                try {
                    var parsed = JSON.parse(existingValue);
                    if (Array.isArray(parsed)) {
                        this.$set(this.form.dynamicFieldsValues, fieldId, parsed);
                        return this.ensureRepeaterHasAtLeastOneRow(fieldId, this.form.dynamicFieldsValues[fieldId], subfields);
                    }
                } catch (e) {
                    this.$set(this.form.dynamicFieldsValues, fieldId, []);
                }
            }

            this.$set(this.form.dynamicFieldsValues, fieldId, []);
            return this.ensureRepeaterHasAtLeastOneRow(fieldId, this.form.dynamicFieldsValues[fieldId], subfields);
        },

        ensureRepeaterHasAtLeastOneRow(fieldId, rows, subfields) {
            if (!Array.isArray(rows)) {
                rows = [];
            }

            if (rows.length > 0) {
                return rows;
            }

            var columnsCount = Array.isArray(subfields) && subfields.length > 0 ? subfields.length : 1;
            var newRow = [];
            for (var index = 0; index < columnsCount; index++) {
                newRow.push('');
            }

            rows.push(newRow);
            this.$set(this.form.dynamicFieldsValues, fieldId, rows);

            return rows;
        },

        addRepeaterRow(fieldId, subfields) {
            var rows = this.getRepeaterRows(fieldId, subfields);
            var columnsCount = Array.isArray(subfields) && subfields.length > 0 ? subfields.length : 1;
            var newRow = [];

            for (var index = 0; index < columnsCount; index++) {
                newRow.push('');
            }

            rows.push(newRow);
            this.$set(this.form.dynamicFieldsValues, fieldId, rows);
        },

        removeRepeaterRow(fieldId, rowIndex, subfields) {
            var rows = this.getRepeaterRows(fieldId, subfields);

            if (rows.length <= 1) {
                var columnsCount = Array.isArray(subfields) && subfields.length > 0 ? subfields.length : 1;
                var emptyRow = [];
                for (var i = 0; i < columnsCount; i++) {
                    emptyRow.push('');
                }
                rows.splice(0, 1, emptyRow);
            } else {
                rows.splice(rowIndex, 1);
            }

            this.$set(this.form.dynamicFieldsValues, fieldId, rows);
        },

        getRepeaterCellValue(fieldId, rowIndex, columnIndex) {
            var rows = this.getRepeaterRows(fieldId);
            if (!rows[rowIndex]) {
                return '';
            }

            return typeof rows[rowIndex][columnIndex] !== 'undefined' && rows[rowIndex][columnIndex] !== null
                ? rows[rowIndex][columnIndex]
                : '';
        },

        setRepeaterCellValue(fieldId, rowIndex, columnIndex, value) {
            var rows = this.getRepeaterRows(fieldId);
            if (!rows[rowIndex]) {
                rows[rowIndex] = [];
            }

            rows[rowIndex][columnIndex] = value;
            this.$set(this.form.dynamicFieldsValues, fieldId, rows);
        },

        correctRepeaterFieldsDecimals(fieldId, rowIndex, columnIndex, $event) {
            var value = $event && $event.target ? $event.target.value : '';
            this.setRepeaterCellValue(fieldId, rowIndex, columnIndex, this.normalizeRepeaterDecimalPoint(value));
        },

        formatRepeaterFieldsAmount(fieldId, rowIndex, columnIndex, $event) {
            var value = $event && $event.target ? $event.target.value : '';
            var sanitized = this.sanitizeRepeaterFloatInput(value, 2);
            if (sanitized + '' === 'NaN') {
                sanitized = '0.00';
            }

            this.setRepeaterCellValue(fieldId, rowIndex, columnIndex, sanitized);
        },

        normalizeRepeaterDecimalPoint(val) {
            val = '' + val;
            return val ? val.replace(',', '.') : val;
        },

        sanitizeRepeaterIncorrectFloatChars(val) {
            val = this.normalizeRepeaterDecimalPoint(val);
            return val
                ? val.replace(/[^0-9\.]/, '').replace(/([0-9]+\.[0-9]+)\..*/, '$1')
                : val;
        },

        sanitizeRepeaterFloatInput(val, minDecimals) {
            if (val == null) {
                return val;
            }

            var sanitized = parseFloat(this.sanitizeRepeaterIncorrectFloatChars(val));
            if ((sanitized || sanitized === 0) && this.countRepeaterDecimals(sanitized) < minDecimals) {
                sanitized = sanitized.toFixed(minDecimals);
            }

            return sanitized + '';
        },

        countRepeaterDecimals(value) {
            if (Math.floor(value) === value) {
                return 0;
            }

            var arr = value.toString().split('.');
            return arr.length === 2 ? arr[1].length : 0;
        },

        getValidationFieldClasses,
    }
};



// WEBPACK FOOTER //
// ./resources/assets/admin/js/app-components/Form/AppForm.js